import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle } from 'lucide-react';

export const Tooltip = ({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      {/* Container for the icon */}
      <div className="relative"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>

      <AnimatePresence>
        {isVisible && (
          // Wrapper div for translation:
          <div className="absolute bottom-full left-0 -translate-x-[2px] mb-2">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.15 }}
              // Apply absolute positioning here:
              className="absolute bottom-full left-0 px-4 py-3 text-sm bg-[var(--cardBackground)] border border-[var(--border)] rounded-md shadow-lg whitespace-normal z-[60] min-w-[280px] max-w-[400px]"
            >
              <div className="text-[var(--text)] leading-6">{content}</div>
              {/* Arrow */}
              <div
                className="absolute top-full left-4 -translate-y-[45%] w-2 h-2 bg-[var(--cardBackground)] border-r border-b border-[var(--border)] rotate-45"
              />
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};